import { useEffect, useRef } from "react"
import { Pannellum } from "pannellum-react"
import { io } from "socket.io-client"
import { useStore } from "../../state/store"

const url = process.env.REACT_APP_MARKETING_SUITE
const role = process.env.REACT_APP_ROLE

export default function PanoViewer({ data }) {
  const pannellum = useRef()
  const socket = useRef()

  const index = useStore(state => state.index360)
  const setIndex = useStore(state => state.setIndex360)

  // const imgUrl = `${process.env.PUBLIC_URL}/assets/images/360/${data[index].img}`
  const imgUrl = `${process.env.PUBLIC_URL || "/"}assets/images/360/${data[index].img}`

  console.log(imgUrl)

  // useEffect(() => {
  //   data[index].locations.map(location => console.log(location))
  //   return () => setIndex(0)
  // }, [])

  const moved = () => {
    if (pannellum.current && socket.current && role === "sender") {
      socket.current.emit("panorama", [
        pannellum.current.getViewer().getPitch(),
        pannellum.current.getViewer().getYaw(),
        pannellum.current.getViewer().getHfov()
      ])
    }
  }
  useEffect(() => {
    if (url && role) {
      socket.current = io(url)
      if (role === "recipient") {
        socket.current.on("panorama", data => {
          if (pannellum.current) {
            pannellum.current.getViewer().lookAt(data[0], data[1], data[2])
          }
        })
      }
    }
  }, [])

  const goToImg = location => {
    if (pannellum.current) {
      pannellum.current.getViewer().lookAt(location.coordinates[0], location.coordinates[1], 0)
    }
    setTimeout(() => setIndex(location.index), 1500)
  }

  return (
    <Pannellum
      onRender={() => moved()}
      ref={pannellum}
      width="100%"
      height="100%"
      image={imgUrl}
      pitch={0}
      autoLoad={true}
      yaw={0}
      hfov={100}
      maxHfov={100}
      maxPitch={55}
      minPitch={-70}
      minHfov={80}
      maxLevel={100}
      //onRender={() => moved()}
      showZoomCtrl={false}
    >
      {data[index].locations.map(location => (
        <Pannellum.Hotspot
          key={location}
          type="custom"
          pitch={location.coordinates[0]}
          yaw={location.coordinates[1]}
          handleClick={() => goToImg(location)}
        />
      ))}
    </Pannellum>
  )
}
